module.exports = {
      id: "download-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#download-icon",
      toString: function () {
        return this.url;
      }
    }